var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53006 10.8659C7.36998 10.8659 7.2179 10.8019 7.10585 10.6898L4.84071 8.42467C4.6086 8.19255 4.6086 7.80836 4.84071 7.57625C5.07283 7.34413 5.45702 7.34413 5.68914 7.57625L7.53006 9.41716L11.6441 5.30311C11.8762 5.071 12.2604 5.071 12.4925 5.30311C12.7247 5.53523 12.7247 5.91942 12.4925 6.15154L7.95427 10.6898C7.84221 10.8019 7.69014 10.8659 7.53006 10.8659Z",
    fill: "#2058E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.6f8d0fb5340c2e8a874c8d1ae335f1a1.svg";
export { ForwardRef as ReactComponent };